const mobileJourneyMap = {
  au: { en: 'au1m', zh: 'au2m' },
  at: { de: 'at1m' },
  bm: { en: 'bm1m' },
  be: { en: 'int_eu_en_mobile' },
  ca: { en: 'ca1m', fr: 'ca2m', zh: 'ca3m' },
  de: { de: 'de1m' },
  ie: { en: 'ie1m' },
  it: { it: 'it1m' },
  nz: { en: 'nz1m', zh: 'nz2m' },
  no: { no: 'no1m' },
  pl: { pl: 'pl1m' },
  sg: { en: 'sg1m', zh: 'sg2m' },
  se: { sv: 'se1m' },
} as const;

const desktopJourneyMap = {
  au: { en: 'au1', zh: 'au2' },
  at: { de: null }, // null will use international flow
  bm: { en: 'bm1' },
  be: { en: 'int_eu_en_desktop' },
  ca: { en: 'ca1', fr: 'ca2', zh: 'ca3' },
  de: { de: 'de1' },
  ie: { en: null }, // null will use international flow
  it: { it: null }, // null will use international flow
  nz: { en: 'nz1', zh: 'nz2' },
  no: { no: null }, // null will use international flow
  pl: { pl: 'pl1' },
  sg: { en: 'sg1', zh: 'sg2' },
  se: { sv: null }, // null will use international flow
} as const;

export const getDefaultLanguageForRegion = (region?: string | null, isMobile?: boolean): string => {
  const normalisedRegion = region?.toLowerCase();
  if (!normalisedRegion) return 'en';
  const regionMap = isMobile
    ? mobileJourneyMap[normalisedRegion as keyof typeof mobileJourneyMap]
    : desktopJourneyMap[normalisedRegion as keyof typeof desktopJourneyMap];
  if (!regionMap) return 'en';
  const languages = Object.keys(regionMap);
  return languages.includes('en') ? 'en' : (languages[0] ?? 'en');
};

export const getDemoSignupJourney = (
  region?: string | null,
  language?: string | null,
  isMobile?: boolean
): string | null => {
  const normalisedRegion = region?.toLowerCase();
  const normalisedLanguage = language?.toLowerCase();

  if (!normalisedRegion || !normalisedLanguage) {
    return null;
  }

  const regionMap = isMobile
    ? mobileJourneyMap[normalisedRegion as keyof typeof mobileJourneyMap]
    : desktopJourneyMap[normalisedRegion as keyof typeof desktopJourneyMap];

  if (!regionMap) {
    return null;
  }

  return (regionMap as Record<string, string>)[normalisedLanguage] ?? null;
};
